import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { BONOS, BONOS_TOTAL } from './salesData';
export function BonosSection() {
  return <section id="bonos" className="bg-ivory py-12 sm:py-16" data-id="element-24" data-mp="13dxnfow04t9k">
      <div className="mx-auto max-w-3xl px-5" data-id="element-25" data-mp="13ccrbuu1h29l">
        <div className="text-center" data-id="element-26" data-mp="yf2tprwhxkao">
          <SectionTag data-id="element-27" data-mp="ye1kzu2yd9w4">🎁 5 Bonos incluidos</SectionTag>
          <h2 className="mt-4 font-display text-[1.8rem] font-semibold text-charcoal sm:text-[2.4rem]" data-id="element-28" data-mp="tfhy9rgjbu2p">
            Siempre incluidos
          </h2>
        </div>

        <ul className="mt-7 divide-y divide-stone overflow-hidden rounded-2xl border border-stone bg-sand/40" data-id="element-29" data-mp="ofc15vrhxfd8">
          {BONOS.map((bono, i) => <motion.li key={bono.num} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i * 0.04
        }} className="flex items-start gap-3 px-4 py-3.5" data-id="element-30" data-mp="fgibkpcl1p96" data-mpi={i}>
              <span className="mt-0.5 font-sans text-sm font-bold leading-tight tabular-nums text-gold-deep/70" data-id="element-31" data-mp="qu38bg22c6au">
                {bono.num}
              </span>
              <div className="flex-1" data-id="element-32" data-mp="hvhufy7jdfge">
                <h3 className="font-display text-lg font-semibold leading-tight text-charcoal" data-id="element-33" data-mp="hwki7x9kb1s3">
                  {bono.title}
                </h3>
                <p className="mt-0.5 font-sans text-[0.8rem] leading-snug text-charcoal/70" data-id="element-34" data-mp="1aivjzb8wn8qh">
                  {bono.desc}
                </p>
              </div>
              <span className="mt-0.5 shrink-0 rounded-full bg-gold px-2.5 py-1 font-sans text-[0.6rem] font-bold uppercase tracking-[0.12em] text-charcoal" data-id="element-35" data-mp="1en37x67jgknn">
                Gratis
              </span>
            </motion.li>)}
        </ul>

        <div className="mt-5 rounded-2xl bg-charcoal px-5 py-4 text-center text-ivory" data-id="element-36" data-mp="1thzn63drm8a8">
          <p className="font-sans text-sm sm:text-base" data-id="element-37" data-mp="1y9ht75unaz22">
            Valor total bonos{' '}
            <span className="tabular-nums opacity-60" style={{
            textDecoration: 'line-through'
          }} data-id="element-38" data-mp="285hxpie0dx4k">
              {BONOS_TOTAL}
            </span>{' '}
            → <span className="font-bold text-gold" data-id="element-39" data-mp="236n3lkalcm55">GRATIS con tu MegaPack</span>
          </p>
        </div>
      </div>
    </section>;
}